import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import CSSZSickLeaveCertificateRequestForChooseOutingsTime from './CSSZSickLeaveCertificateRequestForChooseOutingsTime';

interface Props extends BaseModalProps {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateRequestForChooseOutingsTimeModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateRequestForChooseOutingsTime.modalTitle'>
			<CSSZSickLeaveCertificateRequestForChooseOutingsTime
				item={props.item}
				patientId={props.patientId}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateRequestForChooseOutingsTimeModal;
